/**
 * @typedef {ReturnType<typeof import('widgets/product/ProductDetail').default>} ProductDetail
 */

/**
 * @description Base ApplePayButtonMixin implementation
 * <br>This class is not intended to have a separate DOM representation.
 * @param {ProductDetail} ProductDetail Base widget for extending
 * @returns {typeof ApplePayButtonMixin} Apple Pay Button Mixin
 */
export default function (ProductDetail) {
    /**
     * @class AddToCartMixin
     * @augments ProductDetail
     * @classdesc Represents AddToCartMixin component with next features:
     * 1. Handle error while Apple Pay button click
     * 2. Render Apple Pay Button
     * @category widgets
     * @subcategory product
     */
    class ApplePayButtonMixin extends ProductDetail {
        /**
         * @description Widget initialization
         * @listens "applepay.button.click.validation.error"
         * @returns {void}
         */
        init() {
            super.init();
            this.eventBus().on('applepay.button.click.validation.error', 'applePayErrorHandler');
        }

        /**
         * @description Handle error while Apple Pay button click
         * @param {string} errorMsg Error message
         * @returns {void}
         */
        applePayErrorHandler(errorMsg) {
            this.showCartMessage(errorMsg, true);
        }

        /**
         * @description Update Product View
         * @param {any} product productModel
         */
        updateProductView(product) {
            super.updateProductView(product);
            this.renderApplePayButton(product);
        }

        /**
         * @description Render Apple Pay Button
         * @param {object} product productModel
         * @returns {void}
         */
        renderApplePayButton(product) {
            this.getById('applePayButton', (applePayButton) => {
                applePayButton.renderApplePayButton(product)
                    // eslint-disable-next-line no-console
                    .catch(() => { console.log('Product model not provided to the render method'); });
            });
        }
    }

    return ApplePayButtonMixin;
}
